// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Add, Update, Delete.
// MODIFIED DATE : 14-08-2025

import GroupAccountActionTypes from './groupAccount.types';

/** ***************** ADD GROUP ACCOUNT DETAILS START *********************** */
export const addGroupAccountDetailsStart = (addData: any) => ({
	type: GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const addGroupAccountDetailsSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const addGroupAccountDetailsFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const addGroupAccountDetailsResponseReset = () => ({
	type: GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const addGroupAccountDetailsResponseChanged = () => ({
	type: GroupAccountActionTypes.ADD_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD GROUP ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE GROUP ACCOUNT DETAILS START *********************** */
export const updateGroupAccountDetailsStart = (updateData: any) => ({
	type: GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_START,
	payload: updateData,
});

export const updateGroupAccountDetailsSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const updateGroupAccountDetailsFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const updateGroupAccountDetailsResponseReset = () => ({
	type: GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const updateGroupAccountDetailsResponseChanged = () => ({
	type: GroupAccountActionTypes.UPDATE_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE GROUP ACCOUNT DETAILS END *********************** */

/** ***************** GET GROUP ACCOUNT LIST START *********************** */
export const getGroupAccountListStart = (getData: any) => ({
	type: GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_START,
	payload: getData,
});

export const getGroupAccountListSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const getGroupAccountListFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const getGroupAccountListResponseReset = () => ({
	type: GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_RESPONSE_RESET,
});

export const getGroupAccountListResponseChanged = () => ({
	type: GroupAccountActionTypes.GET_GROUP_ACCOUNT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET GROUP ACCOUNT LIST END *********************** */

/** ***************** GET PRIMARY ACCOUNT LIST START *********************** */
export const getPrimaryAccountListStart = (getData: any) => ({
	type: GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_START,
	payload: getData,
});

export const getPrimaryAccountListSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const getPrimaryAccountListFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const getPrimaryAccountListResponseReset = () => ({
	type: GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_RESPONSE_RESET,
});

export const getPrimaryAccountListResponseChanged = () => ({
	type: GroupAccountActionTypes.GET_PRIMARY_ACCOUNT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PRIMARY ACCOUNT LIST END *********************** */

/** ***************** FETCH GROUP ACCOUNT DETAILS START *********************** */
export const fetchGroupAccountDetailsStart = (addData: any) => ({
	type: GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const fetchGroupAccountDetailsSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchGroupAccountDetailsFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchGroupAccountDetailsResponseReset = () => ({
	type: GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const fetchGroupAccountDetailsResponseChanged = () => ({
	type: GroupAccountActionTypes.FETCH_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH GROUP ACCOUNT DETAILS END *********************** */

/** ***************** DELETE GROUP ACCOUNT DETAILS START *********************** */
export const deleteGroupAccountDetailsStart = (addData: any) => ({
	type: GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const deleteGroupAccountDetailsSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteGroupAccountDetailsFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteGroupAccountDetailsResponseReset = () => ({
	type: GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const deleteGroupAccountDetailsResponseChanged = () => ({
	type: GroupAccountActionTypes.DELETE_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE GROUP ACCOUNT DETAILS END *********************** */

/** ***************** ALL GROUP ACCOUNT EXPORT START *********************** */
export const allGroupAccountExportStart = (exportData: any) => ({
	type: GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_START,
	payload: exportData,
});

export const allGroupAccountExportSuccess = (successData: any) => ({
	type: GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_SUCCESS,
	payload: successData,
});

export const allGroupAccountExportFailure = (failureData: any) => ({
	type: GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_FAILURE,
	payload: failureData,
});

export const allGroupAccountExportResponseReset = () => ({
	type: GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_RESPONSE_RESET,
});

export const allGroupAccountExportResponseChanged = () => ({
	type: GroupAccountActionTypes.ALL_GROUP_ACCOUNT_EXPORT_RESPONSE_CHANGED,
});
/** ***************** ALL GROUP ACCOUNT EXPORT END *********************** */
